import React from 'react';
import { connect } from 'react-redux';
import { validateFloat } from "../../common/validation/Validators"
import Select from 'react-select'

const NICBandRow = ({ index, currency, NIlettersAndValues, nicLettersList, disabled, updateNicBand, setNicBands, nicPeriods }) => {
    const currentIndex = NIlettersAndValues?.[index]

    const RemoveButton = (span) => {
        return (<div className={`col-xs-${span || 2}`}>
            <button
                disabled={disabled}
                className='btn pull-right'
                type='button'
                style={{ marginTop: '1.25rem' }}
                onClick={() => {
                    if (disabled) return
                    NIlettersAndValues.splice(index, 1)
                    setNicBands(NIlettersAndValues)
                }}
            >
                <div style={{ float: "left" }}>Remove</div>
            </button>
        </div>)
    }

    return (
        <div className="col-xs-12">
            <div className={`col-xs-2 pl-0 pr-0`}>
                <div className='form-material form-container'>
                    <label >Letter</label>
                    <Select
                        value={nicLettersList?.find(item => item.value === currentIndex?.NIletter)}
                        isDisabled={disabled}
                        onChange={(selected) => {
                            updateNicBand({ index, NIletter: selected?.value || null })
                        }}
                        options={nicLettersList}
                    />
                </div>
            </div>
            <div className="col-xs-2 pl-0 pr-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Gross Earnings for NI</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.GrossEarningsForNICsYTD}
                        onChange={(e) => {
                            updateNicBand({ index, GrossEarningsForNICsYTD: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-1 pl-0 pr-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >At LEL</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.AtLELYTD}
                        onChange={(e) => {
                            updateNicBand({ index, AtLELYTD: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-1 pl-0 pr-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >LEL to PT</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.LELtoPTYTD}
                        onChange={(e) => {
                            updateNicBand({ index, LELtoPTYTD: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-1 pl-0 pr-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >PT to UEL</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.PTtoUELYTD}
                        onChange={(e) => {
                            updateNicBand({ index, PTtoUELYTD: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-2 pl-0 pr-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Total Employer NIC</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.TotalEmpNICYTD}
                        onChange={(e) => {
                            updateNicBand({ index, TotalEmpNICYTD: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <div className="col-xs-2 pl-0 pr-0">
                <div className='form-material form-container' style={{ position: 'relative' }}>
                    <label >Employee Contributions</label>
                    <div style={{ position: 'absolute', top: 8 }}>
                        {currency}
                    </div>
                    <input
                        style={{ paddingLeft: '1rem' }}

                        className="form-control form-input"
                        value={currentIndex?.EmpeeContribnsYTD}
                        onChange={(e) => {
                            updateNicBand({ index, EmpeeContribnsYTD: validateFloat(e.target.value) })
                        }}
                        disabled={disabled}
                    />
                </div>
            </div>
            <RemoveButton />
        </div>
    )

}


const mapStateToProps = (state, ownProps) => {

    return {
        currency: state.company?.settings?.currency,
    };
};

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(NICBandRow);

